import { render, staticRenderFns } from "./ConsultationSummary.vue?vue&type=template&id=41464fb4&"
import script from "./ConsultationSummary.vue?vue&type=script&lang=js&"
export * from "./ConsultationSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports